import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'secondary' | 'outline' | 'safe' | 'warn' | 'risk';
  className?: string;
}

/**
 * App-standard pill status badge. `safe`/`warn`/`risk` map onto the epic
 * design_html status-pair tokens (bg-*-bg + text-*), so a badge always
 * reads correctly in both themes.
 */
export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  className = ''
}) => {
  const baseStyles = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold';

  const variantStyles = {
    default: 'bg-nav-active text-accent-active',
    secondary: 'bg-ghost-bg text-ink-muted',
    outline: 'border border-line text-ink',
    safe: 'bg-safe-bg text-safe',
    warn: 'bg-warn-bg text-warn',
    risk: 'bg-risk-bg text-risk'
  };

  return (
    <span className={`${baseStyles} ${variantStyles[variant]} ${className}`}>
      {children}
    </span>
  );
};
